var BrowserHelper = /** @class */ (function () {
    function BrowserHelper() {
    }
    /**
     * Checks if current user browser is Internet Explorer 11 or not
     */
    BrowserHelper.isIE11 = function () {
        var userAgent = window.navigator.userAgent;
        return userAgent.indexOf('Trident/') > 0;
    };
    /**
     * Checks if current user browser is Microsoft Edge or not
     */
    BrowserHelper.isEdge = function () {
        var userAgent = window.navigator.userAgent;
        return userAgent.indexOf('Edge/') > 0;
    };
    return BrowserHelper;
}());
export default BrowserHelper;
